import axios from 'axios';

export default {
    loadProjectList() {
        return axios.get('/colab/epr/projects');
    },

    loadProjectById(projectId) {
        return axios.get('/colab/epr/projects/' + projectId);
    },

    updateProject(projectData) {
        return axios.post('/colab/epr/projects/' + projectData.id, projectData);
    },

    deleteProject(projectId) {
        return axios.delete('/colab/epr/projects/' + projectId);
    },

    //#region Superadmin

    /*Superadmin*/

    deleteProjectByAdmin(projectId) {
        return axios.delete(`/colab/epr/admin/project/${projectId}`);
    },

    removeCollaboratorByAdmin(projectId, userId) {
        return axios.delete(`/colab/epr/admin/project/${projectId}/collaborators/${userId}`);
    },

    /*endregion */

    //#region Files

    /* Files */
    loadRawRoot(root) {
        return axios.get('/colab/epr/documents/' + root);
    },

    loadDuplicateProjects(root) {
        return axios.get(`/colab/epr/documents/${root}/duplicates`);
    },

    loadFilesByProject(projectId) {
        return axios.get('/colab/epr/projects/' + projectId + '/documents');
    },

    uploadFile(projectId, fileId, indexData) {
        return axios.post('/colab/epr/projects/' + projectId + '/file/push/' + fileId, indexData);
    },

    editFile(projectId, fileId, indexData) {
        return axios.post('/colab/epr/projects/' + projectId + '/file/update/' + fileId, indexData);
    },

    deleteFile(projectId, fileId, objectTypeId) {
        return axios.delete(`/colab/epr/projects/${projectId}/file/delete/${fileId}/${objectTypeId}`, 
            { // Axios problem - this line will add 'content-type' json to request headers
                data: {}
            });
    },

    getFileShareData(shareToken) {
        return axios.get('/colab/epr/public/share/' + shareToken);
    },

    getFileShareLink(projectId, fileId) {
        return axios.get("/colab/epr/projects/" + projectId + "/content/" + fileId + "/share");
    },

    createFileShareLink(projectId, fileId, params) {
        return axios.post("/colab/epr/projects/" + projectId + "/content/" + fileId + "/share", params);
    },

    removeFileShareLink(projectId, fileId) {
        return axios.delete("/colab/epr/projects/" + projectId + "/content/" + fileId + "/share");
    },

    checkFilePreview(itemId, viewUrl) {
        return axios.get(`${viewUrl}/dashlets/pdfview/web/viewer.html?osid=${itemId}`);
    },

    sendFilesForZip(projectId, selectedFiles) {
        return axios.post(`/colab/epr/projects/${projectId}/multiple/download`, selectedFiles);
    },

    getFileRevisionInfo(projectId, file) {
        return axios.get(`/colab/epr/projects/${projectId}/file/${file.id}/${file.objectTypeId}/revision/info`);
    },

    //#endregion

    loadFeedByProject(projectId) {
        return axios.get('/colab/epr/feed/' + projectId);
    },

    addFeedItem(projectId, item) {
        return axios.post('/colab/epr/feed/' + projectId, item);
    },

    removeFeedItem(projectId, itemId) {
        return axios.delete(`/colab/epr/feed/${projectId}/${itemId}`);
    },

    updateFeedItem(projectId, item) {
        return axios.post(`/colab/epr/feed/${projectId}/edit`, item);
    },

    //#region Collaborators

    /* Collaborators */
    loadCollaboratorsByProject(projectId) {
        return axios.get('/colab/epr/projects/' + projectId + '/collaborators');
    },

    updateCollaboratorStatus(projectId, key, collaboratorStatus) {
        return axios.post(
            '/colab/epr/projects/' + projectId + '/collaborators/' + key,
            {roleId: collaboratorStatus[key]},
            {
                headers: {
                    'content-type': 'application/json;charset=UTF-8'
                }
            }
        );
    },

    removeMemberFromProject(projectId, userId) {
        return axios.delete('/colab/epr/projects/' + projectId + '/collaborators/' + userId);
    },

    //#endregion

    //#region Invitations

    loadInvitationsByProject(projectId) {
        return axios.get('/colab/epr/invite/' + projectId + '/list');
    },

    //#endregion

    //#region Groups

    /* Groups */
    loadGroups(projectId) {
        return axios.get('/colab/epr/projects/' + projectId + '/groups');
    },

    createNewGroup(projectId, groupData) {
        return axios.post('/colab/epr/projects/' + projectId + '/groups', groupData);
    },

    applyGroupChanges(projectId, groupId, groupData) {
        return axios.post('/colab/epr/projects/' + projectId + '/groups/' + groupId, groupData);
    },

    deleteGroup(projectId, groupId) {
        return axios.delete('/colab/epr/projects/' + projectId + '/groups/' + groupId);
    },

    //#endregion

    //#region Tasks

    loadTaskLists(projectId) {
        return axios.get('/colab/epr/projects/' + projectId + '/tasklists');
    },

    loadProjectAssignedTaskLists(projectId) {
        return axios.get('/colab/epr/tasklists/' + projectId + '/assigned');
    },

    createTaskList(tasklist) {
        return axios.post('/colab/epr/tasklists', tasklist);
    },

    editTaskListName(id, projectId, name) {
        return axios.post(`/colab/epr/tasklists/${id}`, {
            id, projectId, name
        });
    },

    deleteTaskList(listId) {
        return axios.delete('/colab/epr/tasklists/' + listId);
    },

    addTask(listId, task) {
        return axios.post('/colab/epr/tasklists/' + listId + '/task', task);
    },

    editTask(listId, taskId, taskData) {
        return axios.post('/colab/epr/tasklists/' + listId + '/task/' + taskId, taskData);
    },

    deleteTask(listId, taskId) {
        return axios.delete('/colab/epr/tasklists/' + listId + '/task/' + taskId);
    },

    markTaskComplete(listId, taskId) {
        return axios.post(
            '/colab/epr/tasklists/' + listId + '/task/' + taskId + '/complete',
            null,
            { headers: { 'content-type': 'application/json' } }
        );
    },

    markTaskNotComplete(listId, taskId) {
        return axios.delete('/colab/epr/tasklists/' + listId + '/task/' + taskId + '/complete');
    },

    //#endregion

    getProjectUploadStatus(projectId) {
        return axios.get(`/colab/epr/projects/${projectId}/uploadStatus`);
    },

    getEmailSettings(projectId) {
        return axios.get(`/colab/epr/settings/${projectId}/email`);
    },

    setEmailSettings(projectId, settings) {
        return axios.post(`/colab/epr/settings/${projectId}/email`, settings);
    },

    postExportSettings(projectId, settings) {
        return axios.post(`/colab/epr/settings/${projectId}/export`, settings);
    },
};
